export function maskEmail(email: string): string {
  const [user, domain] = email.split("@");
  if (!user || !domain) {
    return email;
  } // fallback for invalid email

  const maskedUser = maskNamePart(user);

  return `${maskedUser}@${domain}`;
}

export function maskNamePart(name: string): string {
  if (name.length <= 2) {
    return name[0] + "*".repeat(name.length - 1);
  }
  return name.slice(0, 2) + "*".repeat(name.length - 2);
}

export function maskFullName(firstName: string, lastName: string): string {
  const maskedFirst = maskNamePart(firstName);
  const maskedLast = maskNamePart(lastName);
  return `${maskedFirst} ${maskedLast}`;
}
